import { render, staticRenderFns } from "./ConfiguracaoModulo.vue?vue&type=template&id=4869ce38"
import script from "./ConfiguracaoModulo.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoModulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports